import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import ProgramBreadcrumb from '@/shared/components/ProgramBreadcrumb';
import { getProgramById } from '@/shared/apiHelper';
import ProgramImportListDataTable from './components/ProgramImportListDataTable';

const ProgramImportList = ({ organization, program }) => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">Imported Files</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> /{' '}
            <Link to="/program">Programs</Link>
            <ProgramBreadcrumb program={program} linkSelf={true} /> / Imported Files
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md={12} className="d-flex justify-content-end">
                  <Link
                    style={{ maxWidth: '200px' }}
                    className="btn btn-success account__btn account__btn--small"
                    to={`/program/${program.id}/csv-import`}
                  >
                    New Import
                  </Link>
                </Col>
              </Row>
              <ProgramImportListDataTable
                organization={organization}
                program={program}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

const Wrapper = ({ organization, theme, rtl }) => {
  const { programId } = useParams();
  const [programData, setProgramData] = useState(null);

  useEffect(() => {
    if (organization && programId) {
      getProgramById(organization.id, programId, { hierarchy: true })
        .then((p) => setProgramData(p));
    }
  }, [organization, programId]);

  if (!organization || !programData) return 'Loading...';

  return (
    <ProgramImportList
      organization={organization}
      program={programData}
      theme={theme}
      rtl={rtl}
    />
  );
};

export default withRouter(
  connect((state) => ({
    theme: state.theme,
    rtl: state.rtl,
    organization: state.organization,
  }))(Wrapper)
);